import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { useSelector } from "react-redux"
import { getClockFormat } from "reduxSlices/currentSettingsSlice"
import { orgLocalDateTimeByClockFormat } from "utils/dateHelpers"
import ItemRow from "shared/ItemRow"

const ActionLabel = ({ action }) => {
  const failPattern = /.*failure/g;
  const impersonatePattern = /.*impersonat.*/g;
  const signInPattern = /.*sign_in.*/g;

  const getStyleClass = () => {
    if (action.match(failPattern)) {
      return "font-semibold text-pink-400 bg-pink-100"
    }
    if (action.match(impersonatePattern)) {
      return "font-medium text-gray-800 bg-orange-200"
    }
    if (action.match(signInPattern)) {
      return "font-semibold text-green-400 bg-green-100"
    }

    return "font-semibold bg-gray-200"
  }

  return (
    <span className={clsx("item-row-header-content__action-label", getStyleClass())}>
      {action}
    </span>
  )
}

ActionLabel.propTypes = {
  action: types.string.isRequired,
}

const AuditItem = ({ audit }) => {
  const {
    remoteAddress, impersonator, action, createdAt, organizationName,
  } = audit
  const clockFormat = useSelector(getClockFormat)

  return (
    <ItemRow
      itemRowHeaderContent={(
        <>
          <ActionLabel action={action} />
          <span>{ orgLocalDateTimeByClockFormat(createdAt, clockFormat) }</span>
          <span className="item-row-header-content__ip-address" title={remoteAddress}>{remoteAddress}</span>
          <span className="item-row-header-content__impersonator" title={impersonator?.fullName}>{impersonator?.fullName}</span>
          <span className="item-row-header-content__organization" title={organizationName}>{organizationName}</span>
        </>
      )}
    />
  )
}

AuditItem.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  audit: types.object.isRequired,
}

export default AuditItem
